/*
 * @Author: your name
 * @Date: 2022-02-23 09:06:09
 * @LastEditTime: 2022-03-02 09:26:12
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /demander-manage/src/store/modules/user.js
 */

const getDefaultState = () => {
  return {
    showSiderBar: true,
    showFooter: true,
    routerPath: ''
  }
}

const state = getDefaultState()

const mutations = {
  /**
   * 设置侧边栏是否展示
   * @param {*} state
   * @param {*} showSideBar 侧边栏是否展示 Boolean
   */
  SET_SIDERBAR: (state, showSideBar) => {
    state.showSiderBar = showSideBar
  },
  /**
   * 设置底部是否展示
   * @param {*} state
   * @param {*} showFooter 底部footer是否展示 Boolean
   */
  SET_FOOTER: (state, showFooter) => {
    state.showFooter = showFooter
  },
  SET_ROUTER: (state, data) => {
    state.routerPath = data
  }
}

export default {
  namespaced: true,
  state,
  mutations
}

